import script from "./strike-passed.vue?vue&type=script&lang=js"
export * from "./strike-passed.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__